import { ExcaliburGraphicsContext, Material } from 'excalibur';

export class ShaderFactory {
  private static _instance: ShaderFactory;
  private _graphicsContext: ExcaliburGraphicsContext;

  private constructor() {}

  public static getInstance(): ShaderFactory {
    if (!ShaderFactory._instance) {
      ShaderFactory._instance = new ShaderFactory();
    }
    return ShaderFactory._instance;
  }

  public initialize(graphicsContext: ExcaliburGraphicsContext) {
    this._graphicsContext = graphicsContext;
  }

  public createMaterial(name: string, fragmentSource: string, options: any = {}): Material {
    if (!this._graphicsContext) {
      throw new Error('ShaderFactory not initialized! Call initialize() with graphics context first');
    }

    return this._graphicsContext.createMaterial({
      name,
      fragmentSource,
      ...options
    });
  }
}
